import { UPDATE_TOUR_STATUS_ERROR, UPDATE_TOUR_STATUS_SUCCESS, UserLaneActionTypes } from './types';

export interface UserLaneState {
    updated: boolean;
    error?: Error;
}

export const INITIAL_STATE: UserLaneState = {
    updated: false,
    error: undefined,
};

export default function(state = INITIAL_STATE, action: UserLaneActionTypes) {
    switch (action.type) {
        case UPDATE_TOUR_STATUS_SUCCESS:
            return { ...state, updated: action.payload.updated };
        case UPDATE_TOUR_STATUS_ERROR: {
            return { ...state, updated: false, error: action.error };
        }
        default:
            return state;
    }
}
